import { CustomField } from 'src/app/+shared/custom-fields/models';
import { CustomFieldConfig } from 'src/app/+shared/custom-fields/models/customFieldConfig';
import { InstallationFlowType } from 'src/app/constants/app.constants';
import {
  personalDataCustomFields,
  gasDeviceCustomFields,
  waterDeviceCustomFields,
} from 'src/app/+shared/custom-fields/common-custom-fields';
import { GasDeviceObject } from 'src/app/jurisdiction/facilities-form/facilities-form.domain';

const personalDataFields: CustomField[] = [
  { ...personalDataCustomFields.addressSuffix, row: 1 },
  { ...personalDataCustomFields.housingUnits, row: 2 },
  { ...personalDataCustomFields.apartmentNo, row: 2 },
  { ...personalDataCustomFields.floor, row: 3 },
];

const gasDeviceFields: CustomField[] = [
  { ...gasDeviceCustomFields.ceNumber, row: 1, displayFunction: (value: GasDeviceObject) => !value.deviceRemovedCheckbox },

  { ...gasDeviceCustomFields.power, row: 2 },
  {
    ...gasDeviceCustomFields.selectedGasCategory,
    row: 10,
    readonly: true,
    defaultValue: 'h_gas',
    displayFunction: (value: GasDeviceObject) => !value.deviceRemovedCheckbox,
  },
];

const waterDeviceFields: CustomField[] = [
  { ...waterDeviceCustomFields.specialApplianceDropDown, row: 1, required: true },
  { ...waterDeviceCustomFields.amount, row: 1, required: true },
  { ...waterDeviceCustomFields.vrCold, row: 2 },
  { ...waterDeviceCustomFields.vrHot, row: 2 },
];

const gasApplianceFields = [
  {
    ...gasDeviceCustomFields.applianceType,
    row: 5,
  },
  {
    ...gasDeviceCustomFields.manufacturer,
    row: 6,
  },
  { ...gasDeviceCustomFields.otherManufacturer, row: 6 },
  {
    ...gasDeviceCustomFields.deviceType,
    row: 7,
  },
  {
    ...gasDeviceCustomFields.manufactureYear,
    row: 8,
    displayFunction: (value: GasDeviceObject) => !value.deviceRemovedCheckbox,
  },
  { ...gasDeviceCustomFields.applianceCategory, row: 9, displayFunction: (value: GasDeviceObject) => !value.deviceRemovedCheckbox },
];

const applicationsWithGasAppliance = [
  InstallationFlowType.NewInstallation,
  InstallationFlowType.UpdateInstallation,
  InstallationFlowType.ConversionToGas,
];

export const configs: CustomFieldConfig[] = Object.values(InstallationFlowType).map(applicationType => {
  const applicationSpecificFields: CustomField[] = [];

  if (applicationsWithGasAppliance.includes(applicationType)) {
    applicationSpecificFields.push(...gasApplianceFields);
  }

  if (applicationType !== InstallationFlowType.NewInstallation) {
    applicationSpecificFields.push({
      ...gasDeviceCustomFields.deviceRemovedCheckbox,
      row: 1,
      displayFunction: (_, isReadonly: boolean) => !isReadonly,
    });
  }

  return {
    applicationType,
    fields: [...personalDataFields, ...gasDeviceFields, ...waterDeviceFields, ...applicationSpecificFields],
  };
});
